export const BALANCE_ROUTE_PATH = '/balance';
export const PROPERTY_BALANCE_ROUTE_PATH = '/balance/:propertyId';
